import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getLogTypes: ({ plantCd, commCdType }) => {
		let url = `${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=` + commCdType;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//
	getDependencies: params => {
		let queryStr = '';
		queryStr = utils.$sf_objectToQueryString({
			branch: params.branch,
			lang: params.lang,
			library: params.library,
			service: params.service,
			ver: params.ver,
			currentPage: params.currentPage,
			pageUnit: params.pageUnit
		});

		return client
			.get(`${BASE_URL}/libraryDependency/v1/dependencies${queryStr}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommonCodes: params => {
		let queryStr = '';
		queryStr = utils.$sf_objectToQueryString({
			branch: params.branch,
			lang: params.lang
		});
		return client
			.get(`${BASE_URL}/libraryDependency/v1/commonCodes${queryStr}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
